// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__rSEmC","validationTips":"StatementDescriptor_validationTips__1EY_A"};